<section>
    <div class="average-label">Average</div>
    <div class=" average sticker sticker-custom">{{average}}/{{maxRange}}</div>

    <div class="nps-label">NPS (Net Promoter Score)</div>
    <div class="nps sticker sticker-custom">{{nps}}</div>

    <button class="btn btn-primary" (click)="openModal()">{{"pages.feedbacks.surveyComponents.ratingAnswerComponent.readReviews" | translate}}</button>
</section>
